import type { SVGProps } from 'react';

interface CurrentIconProps {
  title?: string;
  titleId?: string;
}
export const CurrentIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & CurrentIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 24 24"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <path
      d="M7.921 2.3C6.936 1.532 5.5 2.234 5.5 3.482V20.49c0 1.422 1.795 2.046 2.677.93l4.19-5.3a1.65 1.65 0 0 1 1.295-.626h6.852c1.428 0 2.049-1.808.921-2.684z"
      stroke="currentColor"
      strokeWidth={3}
    />
  </svg>
);
